import { colors } from '@/utils';

import { FishWelfareResponse } from '../fishObservationGallery.types';

/** Box stroke per lice class, matching the caption's breakdown categories. */
export const orbitOneAnnotationStrokeByType: Partial<Record<FishWelfareResponse, string>> = {
  [FishWelfareResponse.Female]: colors.palette.purple[500],
  [FishWelfareResponse.FemaleEggstring]: colors.palette.red[500],
  [FishWelfareResponse.Mobile]: colors.palette.yellow[400],
  [FishWelfareResponse.ScottishLice]: colors.palette.green[400],
  [FishWelfareResponse.ActiveWound]: colors.palette.red[400],
  [FishWelfareResponse.HealedWound]: colors.palette.orange[400],
  [FishWelfareResponse.SnoutDamage]: colors.palette.red[400],
};

export const orbitOneAnnotationDefaultStroke = colors.palette.yellow[500];

/** Stroke width in screen pixels (with `non-scaling-stroke`): thinner the further you zoom in. */
export const ORBIT_ONE_ANNOTATION_STROKE = {
  baseWidth: 2,
  minWidth: 0.5,
  /** Outline opacity floor as you zoom in. */
  minOpacity: 0.4,
  /** Opacity reduction per zoom step above 1×. */
  opacityFalloff: 0.2,
} as const;
